// extracted by mini-css-extract-plugin
export var required = "_hg-0";